<script setup>
import { computed } from 'vue';
import {
  Chart as ChartJS,
  Tooltip,
  Title,
  LinearScale,
  CategoryScale,
} from 'chart.js';
import { MatrixController, MatrixElement } from 'chartjs-chart-matrix';
import { Chart } from 'vue-chartjs';

const props = defineProps({
  collection: { type: Object, default: () => ({}) },
  chartOptions: { type: Object, default: () => ({}) },
});

ChartJS.register(
  Tooltip,
  Title,
  LinearScale,
  CategoryScale,
  MatrixController,
  MatrixElement
);

const fontFamily =
  'Inter,-apple-system,system-ui,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif';

const defaultOptions = {
  responsive: true,
  maintainAspectRatio: false,
  animation: { duration: 0 },
  plugins: {
    legend: { display: false },
    tooltip: {
      titleFont: { family: fontFamily },
      bodyFont: { family: fontFamily },
    },
  },
  scales: {
    x: {
      type: 'category',
      ticks: { font: { family: fontFamily } },
      grid: { display: false },
    },
    y: {
      type: 'category',
      offset: true,
      ticks: { font: { family: fontFamily } },
      grid: { display: false },
    },
  },
};

const options = computed(() => ({ ...defaultOptions, ...props.chartOptions }));
</script>

<template>
  <Chart type="matrix" :data="collection" :options="options" />
</template>
